import type { ComponentRenderMonitorDefinition } from "@repo/monitoring/component";

export const amcPdpComponentRenderMonitors: ComponentRenderMonitorDefinition[] = [
  {
    componentName: "AMCHeading",
    rootSelector: '[data-cmp="AMCHeading"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AMCHeadingBottom",
    rootSelector: '[data-cmp="AMCHeadingBottom"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AMCBreadcrumb",
    rootSelector: '[data-cmp="AMCBreadcrumb"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AMCPerformanceGraph",
    rootSelector: '[data-cmp="AMCPerformanceGraph"]',
    renderTimeoutMs: 8000,
  },
  {
    componentName: "AMCSipCalculator",
    rootSelector: '[data-cmp="AMCSipCalculator"]',
    successSelector: '[data-cmp="SipCalculator"]',
    renderTimeoutMs: 4000,
  },
  {
    componentName: "AMCRTE",
    rootSelector: '[data-cmp="AMCRTE"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AboutFund",
    rootSelector: '[data-cmp="AboutFund"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "FundHoldings",
    rootSelector: '[data-cmp="FundHoldings"]',
    renderTimeoutMs: 4000,
  },
  {
    componentName: "RiskoMeter",
    rootSelector: '[data-cmp="RiskoMeter"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "OtherFunds",
    rootSelector: '[data-cmp="OtherFunds"]',
    renderTimeoutMs: 4000,
  },
  {
    componentName: "AMCVideoCarousel",
    rootSelector: '[data-cmp="AMCVideoCarousel"]',
    renderTimeoutMs: 6000,
  },
  {
    componentName: "AMCFaqs",
    rootSelector: '[data-cmp="AMCFaqs"]',
    renderTimeoutMs: 4000,
  },
  {
    componentName: "AMCRelatedArticles",
    rootSelector: '[data-cmp="AMCRelatedArticles"]',
    renderTimeoutMs: 4000,
  },
  {
    componentName: "AMCRelatedLinks",
    rootSelector: '[data-cmp="AMCRelatedLinks"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AMCDisclaimer",
    rootSelector: '[data-cmp="AMCDisclaimer"]',
    renderTimeoutMs: 3000,
  },
  {
    componentName: "AMCStickyHeader",
    rootSelector: '[data-cmp="AMCStickyHeader"]',
    renderTimeoutMs: 3000,
  },
];
